import {
  AsyncPropSelector,
  ApiProgressLoader,
  BackgroundIcon
} from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import envConfig from '@nile/home/src/Config/env';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';
import { getClientSiteVariablesById } from '@nile/graphql';

export const Wrap = styled.div`
  max-width: 100%;
  min-height: 38px;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
`;

export const WrapperTag = styled.div.attrs({
  className: 'full-height'
})``;

const StyledTag = styled.div`
  background: var(--sops-light-blue);
  padding: 4px 10px;
  border-radius: 4px;
  text-transform: uppercase;
  font-weight: 500;
`;

function InlineSelect(props) {
  const {
    cell,
    params,
    _ticket,
    mode = 'view',
    updateFieldState,
    type,
    isClearable
  } = props;
  const allProps = params || cell.column;
  const {
    editable,
    field,
    actions,
    accessor,
    entity,
    autoSave,
    parentField,
    dependantField,
    shouldFreezeCell
  } = allProps;
  const isCellFreezed = shouldFreezeCell && shouldFreezeCell(cell);
  const ticket = _ticket || cell?.row?.original;
  const isEditable = !isCellFreezed && editable;
  const [popoverActive, setPopoverActive] = useState(false);
  const [updatedProperties, setUpdatedProperties] = useState({});
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const activator = (
    <div className="ml8 fx center" onClick={() => togglePopoverActive()}>
      <SVGIcon name="Edit" />
    </div>
  );

  const updateSelectedProperties = (changedProperties) => {
    const newProperties = {
      ...updatedProperties,
      ...changedProperties
    };
    setUpdatedProperties(newProperties);
    updateFieldState(newProperties);
  };

  const updateSelection = (f, val) => {
    let serialisedValue = null;
    let updatedProperty = {};
    if (field.isCustom) {
      updateSelectedProperties('customFields', val);
    } else {
      if (val) {
        switch (field.name) {
          case 'techGroup':
            serialisedValue = { groupId: val.groupId, name: val.name };
            break;
          case 'technician':
            serialisedValue = { userId: val.userId };
            break;
          case 'sop':
            serialisedValue = { sopId: val.sopId, name: val.name };
            break;
          case 'site':
            serialisedValue = { id: val.id, name: val.name };
            break;
          default:
            serialisedValue = val.name;
        }
      }
      updatedProperty = { [field.name]: serialisedValue };
      if (parentField.name === f.name && dependantField) {
        updatedProperty = {
          ...updatedProperty,
          [dependantField.name]: null
        };
      }
      updateSelectedProperties(updatedProperty);
    }
  };

  const getVariables = () => {
    switch (field.name) {
      case 'site':
      case 'site.name':
        return ticket?.client?.accountId
          ? getClientSiteVariablesById(ticket.client.accountId)
          : null;
      default:
        return undefined;
    }
  };

  //TODO :: render value in a proper way for NA - vignesh
  const displayVal = cell
    ? props.column.subAccessor
      ? cell.value[props.column.subAccessor]
      : cell.value
      ? cell.value.name || cell.value
      : ''
    : ticket[accessor]
    ? typeof ticket[accessor] === 'object'
      ? ticket[accessor].name
        ? ticket[accessor].name
        : ticket[accessor].firstName
        ? ticket[accessor].firstName + ' ' + ticket[accessor].lastName
        : ticket[accessor].label
      : ticket[accessor]
    : '';

  const fieldValue = updatedProperties[field.name] || ticket[field.name];
  const defaultValue = fieldValue
    ? typeof fieldValue === 'object'
      ? {
          name: fieldValue.name,
          label: fieldValue.name,
          value: fieldValue.name
        }
      : { name: fieldValue, label: fieldValue, value: fieldValue }
    : '';

  const parentFieldValue = updatedProperties.hasOwnProperty(parentField?.name)
    ? updatedProperties[parentField.name]
    : ticket[parentField?.name];

  const Tag = type === 'tag' ? StyledTag : WrapperTag;
  return mode === 'view' ? (
    <Wrap
      className={`${
        isEditable ? 'editable-cell' : 'cell'
      } flex center full-height inlineSelect`}
    >
      <Tag className="ellipsis self-center flex center" title={displayVal}>
        {displayVal || <DisabledTag>NA</DisabledTag>}
      </Tag>
      {isEditable && <div className="edit-actions">{activator}</div>}
    </Wrap>
  ) : (
    <Wrap className="editable-cell pl8 pr8">
      <AsyncPropSelector
        defaultValue={defaultValue}
        updateSelection={updateSelection}
        parentValue={parentFieldValue}
        ticket={ticket}
        field={field}
        entity={entity || 'Ticket'}
        variables={getVariables()}
        hideTitle
        defaultMenuIsOpen
        isClearable={isClearable}
      />
    </Wrap>
  );
}

export default InlineSelect;

export { StyledTag };
